import { SpinInfoResponse, User } from '@cgs/data-access';
import { MachineStateDto, StartStateDto } from '@cgs/provider-cgs';
import { TrifectaSDKLaunchParams } from '../sdk/trifecta-sdk.adapter';

export const TRIFECTA_LAUNCH_PARAMS_TOKEN = Symbol('TRIFECTA_LAUNCH_PARAMS_TOKEN');

export interface TrifectaLaunchParamsDto extends TrifectaSDKLaunchParams {
  gameId: string;
  rtp: number;
  initData: StartStateDto;
  resumeData?: ResumeDataDto;
  replayData?: ReplayDataDto;
  promotionalSpinsData?: PromotionalSpinsDataDto;
  buyFeatureMultiplier: number;
  isRecovery: boolean;
  hitRate: number;
  volatility: string;
  buyBonusRtp: number;
  isStaticReplay?: boolean;
}

export interface PromotionalSpinsDataDto {
  id: string;
  bet: number;
  remainingRounds: number;
  totalRounds: number;
  totalAmountWon: number;
}

export interface ResponsePromotionalSpinsDataDto {
  id: string;
  bet: number;
  remainingRounds: number;
  totalRounds: number;
  totalWin: number;
}

export interface ResumeDataDto {
  spins: MachineStateDto[];
  bet: number;
}

export function isResumeDataDto(data: any): data is ResumeDataDto {
  return 'spins' in data && 'bet' in data;
}

export interface ReplayDataDto {
  balance: number;
  spins: MachineStateDto[];
  bet: number;
  date: number;
  roundId: string;
  type: 'dynamic' | 'static';
}

export class TrifectaSpinResultResponse {
  balance: number;
  sequence: number;
  spin: MachineStateDto;
  promotionalSpinsData?: ResponsePromotionalSpinsDataDto;
}

// TODO: remove the nested spin wrapper once Trifecta reworks the gamble
// response shape on their side (SDK/backend refactoring)
export class TrifectaGambleResultResponse {
  balance: number;
  sequence: number;
  spin: {
    action: string;
    spin: MachineStateDto;
  };
}

export function isTrifectaSpinResultResponse(
  response: any
): response is TrifectaSpinResultResponse {
  return 'spin' in response && 'balance' in response && 'sequence' in response;
}

export class TrifectaFunSpinResultResponse {
  balance: number;
  sequence: number;
  spins: MachineStateDto[];
}

export class TrifectaSpinResponse {
  response: SpinInfoResponse;
  promotionalSpinsData?: ResponsePromotionalSpinsDataDto;
}

export interface TrifectaAckSpinResultResponse {
  spin: MachineStateDto;
}

export function isTrifectaAckSpinResultResponse(
  response: any
): response is TrifectaAckSpinResultResponse {
  return 'spin' in response && !('balance' in response) && !('sequence' in response);
}

export interface TrifectaAckBalanceResultResponse {
  balance: number;
}

export type TrifectaAckResultResponse =
  | TrifectaAckBalanceResultResponse
  | TrifectaAckSpinResultResponse;

export type TrifectaAckResult = User | SpinInfoResponse;

export interface TrifectaErrorResponseDto {
  error: {
    code: string;
    message: string;
  };
}

export interface TrifectaDemoPlayResponseDto {
  bet: number;
  spins: MachineStateDto[];
}
